import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAllPortfolioAction } from '../../../../utils/redux/portfolio/portfolioActions';
import { Link } from 'react-router-dom';

const PortfolioListing = () => {
    const { portfolios, isLoading } = useSelector(state => state.portfolio);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchAllPortfolioAction());
    }, [])
    return (
        <>
            <div className="d-flex flex-column align-items-center">
                <div className="d-flex my-4 w-100 justify-content-between">
                    <h3>Project Portfolio</h3>
                    <Link to="/create-portfolio" className="btn btn-primary">
                        + Add Project
                    </Link>
                </div>

                <div className="w-100">
                    <table className="table table-sm align-middle mt-3">
                        <thead className="table-secondary">
                            <tr>
                                <th className="p-3">Name</th>
                                <th className="p-3">Type</th>
                                <th className="p-3">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {portfolios?.length ? (
                                portfolios?.map((item, index) => (
                                    <tr key={item?._id}>
                                        <td>
                                            <Link to={`/portfolio/${item._id}`}>
                                                {item?.name || `Home Project ${index}`}
                                            </Link>
                                        </td>
                                        <td>{item?.type}</td>
                                        <td>
                                            <button
                                                className="btn btn-sm text-danger"
                                            // onClick={() => handleDelete(item._id)}
                                            >
                                                Remove
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" className="text-center text-muted">
                                        {isLoading ? "Loading..." : "No Project found"}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default PortfolioListing